import { CONTENT_MAX_LENGTH } from "@narratenow/shared";

const ARTICLE_SELECTORS = [
  "article",
  '[role="article"]',
  ".post-content",
  ".article-content",
  ".entry-content",
  ".post-body",
  "main",
] as const;

export function detectArticleContent(): string | null {
  for (const selector of ARTICLE_SELECTORS) {
    const el = document.querySelector(selector);
    if (el) {
      const text = extractText(el);
      if (text.length > 100) {
        return text;
      }
    }
  }

  return null;
}

function extractText(el: Element): string {
  const clone = el.cloneNode(true) as Element;

  // Strip non-content elements. `noscript` and `[hidden]` are never shown to the
  // reader, so narrating them is wrong on its own terms — and because their
  // contents vary with the visitor's browser they also destabilise the content
  // hash the API caches on, turning cache hits into fresh synthesis.
  const remove = clone.querySelectorAll(
    "script, style, noscript, nav, header, footer, aside, iframe, form, " +
      ".narratenow-widget, .ba-widget, [aria-hidden='true'], [hidden]",
  );
  remove.forEach((node) => node.remove());

  const raw = clone.textContent ?? "";

  return raw.replace(/\s+/g, " ").trim().slice(0, CONTENT_MAX_LENGTH);
}

export function detectArticleId(): string {
  // Canonical URL is the most stable identifier.
  const canonical = document.querySelector<HTMLLinkElement>(
    'link[rel="canonical"]',
  );
  if (canonical?.href) {
    return canonical.href;
  }

  // Fall back to cleaned pathname.
  return window.location.origin + window.location.pathname;
}
